module.exports = __webpack_public_path__ + "static/img/pd_top_6.4d45953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_top_6.jpg
// module id = E+wh
// module chunks = 51